import React, { useMemo } from 'react'
import { object, string } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import Breadcrumbs from '@/components/Breadcrumbs'
import { isAgentApp } from '@/utils'

const breadcrumbsWrapperCss = (theme) => css`
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.layout.breadcrumbs.borderColor};
  background: ${theme.colors.white};
  padding: 0px 16px;

  ${mediaQueries.mediumScreen(100)} {
    border-bottom: none;
    padding: 0;
    width: auto;
  }
`

const buildBreadcrumbs = (expert) => {
  const items = [{ path: isAgentApp ? null : '/partners/', title: 'Partners' }]

  if (expert?.name) {
    items.push({ path: null, title: expert.name })
  }

  return items
}

const ExpertBreadcrumbs = ({ expert, className }) => {
  const breadcrumbsItems = useMemo(() => buildBreadcrumbs(expert), [expert])

  return (
    <div css={breadcrumbsWrapperCss} className={className}>
      <Breadcrumbs items={breadcrumbsItems} />
    </div>
  )
}

ExpertBreadcrumbs.propTypes = {
  expert: object,
  className: string,
}

export default ExpertBreadcrumbs
